import { themes } from "../MatxTheme/options/initThemes";
import layout1Settings from "./Layout1/Layout1Settings";
import layout2Settings from "./Layout2/Layout2Settings";

// UPDATE BELOW CODE
// DOC http://demos.ui-lib.com/matx-react-doc/layout.html


// Get the value of "some_key" in eg "https://example.com/?some_key=some_value"
let mode = localStorage.getItem("mode"); // "some_value"

export const MatxLayoutSettings = {
  activeLayout: "layout1", // layout1, layout2
  activeTheme: mode === "dark" ? "caaDark" : "caaLight", // View all valid theme colors inside MatxTheme/themeColors.js
  perfectScrollbar: false,

  themes: themes,
  layout1Settings, // open Layout1/Layout1Settings.js
  layout2Settings, // open Layout1/Layout2Settings.js

  secondarySidebar: {
    show: true,
    open: false,
    theme: "caaDark" // View all valid theme colors inside MatxTheme/themeColors.js
  },
  // Footer options
  footer: {
    show: false,
    fixed: false,
    theme: "caaDark" // View all valid theme colors inside MatxTheme/themeColors.js
  }
};
